import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('runnit-dynamic-field-label-row',{attrs:{"field":_vm.field,"adminOnly":_vm.adminOnly}}),_c(VTextField,{class:{
			required: !!_vm.field.required,
		},attrs:{"required":!!_vm.field.required,"placeholder":_vm.field.placeholder,"dense":"","filled":"","flat":"","solo-inverted":"","hide-details":"auto","counter":_vm.value && _vm.value.length >= _vm.DEFAULT_SHOW_TEXT_COUNTER_AT ? _vm.DEFAULT_TEXT_MAX_LENGTH : null,"rules":_vm.field.required ? _vm.rules.requiredTextField : _vm.rules.optionalTextField,"value":_vm.value},on:{"input":_vm.onFieldInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }